import { createSelector } from '@reduxjs/toolkit';
import { useGetDocumentTagsQuery } from 'features/documents/documents';
import HelperFunctions from 'pages/global/HelperFunctions';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

const emptyArray = [];

export function useGetDocumentTags(id = undefined, tagGroupId, globalTagGroupId) {
    const { documentId } = useParams();
    const idAsNumber = id ?? parseInt(documentId);

    const sortTags = useMemo(() => {
        // Return a unique selector instance for this page so that
        // the filtered results are correctly memoized
        return createSelector(
            (data) => data,
            (_data, tagGroupId) => tagGroupId,
            (_data, _tagGroupId, globalTagGroupId) => globalTagGroupId,
            (data, tagGroupId, globalTagGroupId) => {
                return data
                    ? data
                          .filter((tag) => {
                              if (tagGroupId !== undefined) {
                                  return tag.tagGroup === tagGroupId;
                              }

                              if (globalTagGroupId !== undefined) {
                                  return tag.globalTagGroupId === globalTagGroupId;
                              }

                              return true;
                          })
                          .sort(HelperFunctions.sortByString('name'))
                    : emptyArray;
            },
        );
    }, []);

    const { documentTags } = useGetDocumentTagsQuery(idAsNumber, {
        selectFromResult: ({ data }) => ({
            documentTags: sortTags(data, tagGroupId, globalTagGroupId),
        }),
        skip: !idAsNumber,
    });

    return documentTags;
}
